import { Component, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UserActionStatusService } from "../../service/user-action-status.service";

@Component({
    selector: 'resync-actions-dialog',
    template: require('./resync-actions-dialog.component.html')
})
export class ResyncActionsDialogComponent {

    thingWorkingHours: number;

    private thingId: string;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<ResyncActionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        @Inject(forwardRef(() => UserActionStatusService)) private userActionStatusService: UserActionStatusService
    ) {
        this.thingId = data.thingId;
        this.getWorkingHours();
    }

    private getWorkingHours(): void {
        this.userActionStatusService.getActionSynchronizerConfig(this.thingId).then(resp => this.thingWorkingHours = resp.workingHours).catch(() => { });
    }

    save(): void {
        this.dialogRef.close({ thingWorkingHours: this.thingWorkingHours });
    }
}